// extracted by mini-css-extract-plugin
export default {"box":"ScoreBox_box__wPQdd","nan":"ScoreBox_nan__prsCZ"};